var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 660,
    height: 214,
    viewBox: "0 0 660 214",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_30)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M429.823 0.110992C382.988 0.110992 341.134 24.393 341.134 69.256C341.134 120.706 415.364 124.259 415.364 150.106C415.364 160.989 402.895 170.731 381.6 170.731C351.377 170.731 328.789 157.119 328.789 157.119L319.123 202.391C319.123 202.391 345.145 213.889 379.692 213.889C430.898 213.889 471.19 188.415 471.19 142.784C471.19 88.419 396.652 84.971 396.652 60.981C396.652 52.455 406.887 43.114 428.122 43.114C452.081 43.114 471.628 53.014 471.628 53.014L481.087 9.289C481.087 9.289 459.818 0.110992 429.823 0.110992ZM1.32941 3.411L0.195312 10.011C0.195312 10.011 19.8988 13.618 37.645 20.814C60.495 29.064 62.122 33.868 65.971 48.786L107.905 210.486H164.118L250.719 3.411H194.635L138.989 144.202L116.282 24.861C114.199 11.203 103.651 3.411 90.74 3.411H1.32941ZM273.271 3.411L229.275 210.486H282.756L326.598 3.411H273.271ZM571.554 3.411C558.658 3.411 551.825 10.318 546.811 22.386L468.458 210.486H524.542L535.393 179.136H603.72L610.318 210.486H659.805L616.633 3.411H571.554ZM578.848 59.356L595.473 137.061H550.935L578.848 59.356Z",
    fill: "#1434CB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_30"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 660,
    height: 214,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.b57daa2a41ecfe79a87f17f6b06aa668.svg";
export { ForwardRef as ReactComponent };